import { LIVE_TRACKING_UPDATE, BULK_CANCEL_ISINPROGRESS } from '../../../actions/constants/types';

const initialState = {
  liveTracking: true,
  isBulkCancelInProgress: false,
};

function moreOptions(state = initialState, action) {
  switch (action.type) {
    case LIVE_TRACKING_UPDATE: {
      return {
        ...state,
        liveTracking: action.value,
      };
    }
    case BULK_CANCEL_ISINPROGRESS: {
      return {
        ...state,
        isBulkCancelInProgress: action.value,
      };
    }
    default: {
      return state;
    }
  }
}

export default moreOptions;
